function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function TrovoIcon(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 7680 7230",
        fill: "currentColor"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4250 7004 c-19 -2 -79 -9 -133 -15 -481 -52 -996 -273 -1417 -608 -118 -94 -314 -289 -403 -401 -237 -298 -413 -658 -517 -1055 -93 -360 -125 -647 -117 -1066 5 -303 59 -270 -403 -248 -118 6 -311 13 -427 16 -353 10 -351 12 -429 -462 -22 -137 -40 -247 -64 -395 -12 -74 -28 -175 -36 -225 -8 -49 -21 -133 -29 -185 -8 -52 -22 -138 -30 -190 -8 -52 -24 -153 -35 -225 -11 -71 -27 -173 -35 -225 -9 -52 -22 -135 -29 -185 -37 -241 -68 -439 -82 -525 -8 -52 -18 -141 -21 -197 -10 -175 10 -185 300 -153 188 20 246 27 572 70 290 38 369 49 485 65 63 9 160 23 215 30 204 28 403 55 500 69 55 8 152 22 215 31 63 9 162 23 220 31 305 43 264 48 381 -47 477 -391 1116 -771 1454 -866 179 -50 261 -47 350 13 65 44 83 71 161 255 36 85 69 163 74 174 5 11 56 132 115 268 166 389 271 587 326 614 13 6 62 16 109 23 47 6 128 18 180 25 178 25 315 45 460 65 80 11 192 27 250 35 58 8 141 19 185 25 44 5 107 14 140 20 59 9 206 30 505 70 427 57 443 69 360 280 -22 58 -61 157 -85 220 -25 63 -82 212 -128 330 -46 118 -105 269 -130 335 -178 463 -173 453 -237 485 -62 32 -86 34 -750 70 -1403 77 -1649 134 -1970 459 -321 324 -458 740 -395 1201 65 487 362 823 802 906 161 30 354 4 511 -71 254 -120 412 -360 412 -624 0 -205 -88 -370 -239 -444 -59 -29 -74 -32 -156 -32 -76 0 -99 5 -145 26 -102 48 -140 101 -140 194 0 79 24 124 102 197 59 55 62 59 62 106 0 118 -129 182 -277 137 -153 -46 -265 -166 -319 -340 -30 -97 -31 -269 -1 -372 85 -288 326 -492 643 -542 84 -14 296 -14 380 0 364 58 663 326 790 707 49 149 63 247 63 442 0 153 -4 202 -22 285 -69 316 -207 570 -440 808 -317 324 -754 538 -1221 597 -90 12 -401 21 -460 14z"
        })
    }));
}
